/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:block;padding:30px 40px 20px;text-align:center}h1[_ngcontent-%COMP%]{min-height:40px;padding-bottom:5px}.msg-content[_ngcontent-%COMP%]{font-size:1.125em;margin-bottom:1em;margin-top:1em;text-align:center}button[_ngcontent-%COMP%]{min-width:130px}"];
export { styles as styles };
